import http from "../../network/HTTPClient";

const AuthService = {
  login(data) {
    return http.post("login", data);
  },
  logout(data) {
    return http.post("logout", data);
  },
  hasAccess(data) {
    return http.post("hasAccess", data);
  },
};

export default AuthService;
